import GeneralServices from "./GeneralServices";
import { IGetStats, IGetStatsError, IGetStatsOK, IGetStatsResponseData } from "./StatsServices.dto";

class StatsServices {
  getStats = async (args: IGetStats): Promise<IGetStatsOK | IGetStatsError> => {
    try {
      const response: { data: IGetStatsResponseData } = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader,
        endpoint: `stats`
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (err) {
      return {
        ok: false,
      };
    }
  };

  getCampaignStats = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader && (args.loader === false ? false : true),
        endpoint: `stats/campaigns?campaign=${args.id}`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  };
}

export default new StatsServices();
